<template >
    <div class="save-card-dialog">
        <el-dialog
        :visible.sync="visible"
        :title="form.id ? $t('Card.edit') : $t('Card.add') + title"
        left>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="160px"
                label-suffix=":"
            >
                <el-form-item prop="name" :label="$t('Reception.First.card_name')">
                    <el-input style="width: 210px;" type="text" v-model="form.name" />
                </el-form-item>
                <el-form-item :label="$t('Card.image')" >
                    <div class="image-item"
                        v-if="form.image"
                        :style="`background-image: url(${form.image})`">
                    </div>
                    <div v-if="!form.image" class="flex items-center">
                        <file-upload ref="upload" :num="1" @input="addImg(arguments)" :multiple="true">
                            <div class="balance-pic flex items-center justify-center">
                                <i class="el-icon-plus"></i>
                            </div>
                        </file-upload>
                    </div>
                </el-form-item>
                <template v-if="activeName==='memberCard'">
                    <el-form-item prop="cardType" :label="$t('Card.type')" >
                        <el-select
                            :disabled="form.id ? true : false"
                            v-model="form.cardType"
                            :placeholder="$t('Choose.card_type')"
                            clearable >
                            <el-option :label="$t('Card.secondary_card_type')" :value="2" />
                            <el-option :label="$t('Card.term_type')" :value="3" />
                        </el-select>
                    </el-form-item>
                    <div class="box-1e" style="min-height:110px" v-if="form.cardType">
                        <el-form-item
                            :label="form.cardType===2 ? $t('Card.effective_number') : $t('Card.effective_day')"
                            label-width="140px">
                            <el-input type="number" v-model="form.credit" />
                             {{ form.cardType===2 ? $t('Week.ci') : $t('Week.day2') }}
                        </el-form-item>
                        <el-form-item
                            :label="form.cardType===2 ? `${$t('Card.gift_time')}≤` : `${$t('Card.gift_day')}≤`"
                            prop="giftCredit"
                            label-width="140px">
                            <el-input type="number" v-model="form.giftCredit" />
                             {{ form.cardType===2 ? $t('Week.ci') : $t('Week.day2') }}
                        </el-form-item>
                    </div>
                </template>
                <el-form-item
                    v-if="Number(form.cardType) !== 3"
                    prop="validPeriod"
                    :label="$t('Reception.First.validity')">
                    <el-input type="number" v-model.number="form.validPeriod"/> {{ $t('Week.day2') }}
                </el-form-item>
                <el-form-item
                    prop="actualValue"
                    :label="$t('Card.actual_value')"
                    v-if="activeName==='storedValueCard'">
                    <el-input type="number" v-model.number="form.actualValue" />
                     {{ $t('Reception.Fifth.yuan') }}
                </el-form-item>
                <el-form-item prop="basePrice" :label="$t('Card.sell_base_amt')">
                    <el-input type="number" v-model.number="form.basePrice" />
                     {{ $t('Reception.Fifth.yuan') }}
                </el-form-item>
                <el-form-item prop="transferFee" :label="$t('Reception.Fifth.transfer')">
                    <el-select
                        v-model="form.transferType"
                        :placeholder="$t('Choose.transfer_type')"
                        class="w-full" clearable >
                        <el-option :label="$t('Reception.Fifth.bai')" :value="1" />
                        <el-option :label="$t('Reception.Fifth.amt')" :value="2" />
                    </el-select>
                    <span class="ml-2">
                        <el-input type="number" v-model.number="form.transferFee" />
                        {{ form.transferType === 1 ? '%' : $t('Reception.Fifth.yuan') }}
                    </span>
                </el-form-item>
                <el-form-item prop="supportStoreType" :label="$t('Contract.support_store')">
                    <el-radio-group v-model="form.supportStoreType">
                        <el-radio :label="1">{{ $t('Card.single_store') }}</el-radio>
                        <el-radio :label="2">{{ $t('Staff.tong_store') }}</el-radio>
                        <el-radio :label="3">{{ $t('Staff.all_store') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="form.supportStoreType === 2" class="box-1e">
                    <el-form-item
                        prop="supportStoreLimit"
                        :label="$t('Choose.tong_store')"
                        label-width="160px">
                        <el-input
                            class="input-1 width-2"
                            type="text"
                            v-model="form.supportStoreLimit" />
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox
                            :indeterminate="isSupportIndeterminate"
                            v-model="checkAll"
                            @change="handleCheckAllChange"
                        >{{ $t('Course.check_all') }}</el-checkbox>
                        <div class="box-a">
                            <el-checkbox-group
                                v-model="form.supportStoreIds"
                                @change="handleCheckedSupportStoresChange">
                                <el-checkbox
                                    style="width:100%; margin: 0px 5px"
                                    v-for="item in stores"
                                    :label="item.id"
                                    :key="item.id"
                                >{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>
                </div>
                <el-form-item :label="$t('Sell.store')" prop="sellStoreIds">
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAllStore"
                        @change="handleCheckAllStoreChange"
                    >{{ $t('Course.check_all') }}</el-checkbox>
                    <div class="card-check-store">
                        <el-checkbox-group
                            v-model="form.sellStoreIds"
                            @change="handleCheckedStoresChange">
                            <el-checkbox
                                style="width:100%; margin: 0px 5px"
                                v-for="item in stores"
                                :label="item.id"
                                :key="item.id">
                                {{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <template v-if="activeName==='storedValueCard'">
                    <el-form-item prop="formalMemberOnly" :label="$t('Member.if')" >
                        <el-radio
                            v-model="form.formalMemberOnly"
                            :label="1"
                        >{{ $t('Common.yes') }}</el-radio>
                        <el-radio
                            v-model="form.formalMemberOnly"
                            :label="2"
                        >{{ $t('Common.no') }}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('Sell.Pay.methods2')">
                        <el-checkbox-group v-model="form.consumeWays">
                            <el-checkbox
                                v-for="item in options"
                                :label="item.code"
                                :key="item.code"
                            >{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </template>
                <div class="flex store-value-date">
                    <el-form-item prop="saleBegin" :label="$t('Sell.Time.sell')">
                        <el-date-picker
                            v-model="form.saleBegin"
                            value-format="yyyy-MM-dd"
                            type="date"
                            style="width:200px"
                            :placeholder="$t('Common.choose_date')">
                        </el-date-picker>
                    </el-form-item>
                    ~
                    <el-form-item prop="saleEnd" class="store-sell-end">
                        <el-date-picker
                            v-model="form.saleEnd"
                            type="date"
                            style="width:200px"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('Common.choose_date')">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <el-form-item
                    prop="experienceCard"
                    :label="$t('Member.if_experience')"
                    v-if="activeName==='memberCard'">
                    <el-radio
                        v-model="form.experienceCard"
                        :label="2"
                    >{{ $t('Common.no') }}</el-radio>
                    <el-radio
                        v-model="form.experienceCard"
                        :label="1"
                    >{{ $t('Member.is_experience') }}</el-radio>
                    <span></span>
                </el-form-item>
                <el-form-item prop="remark" :label="$t('Common.remark')">
                    <el-input type="textarea" v-model="form.remark" />
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button
                    @click="confirm"
                    type="primary"
                >{{ $t('Common.save') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
} from 'element-ui';
import FileUpload from '@/components/base/FileUpload.vue';

export default {
    props: ['activeName'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckboxButton: CheckboxButton,
        ElTimePicker: TimePicker,
        ElRow: Row,
        FileUpload,
    },
    data() {
        return {
            title: this.$t('Card.card1'),
            url: 'stored-value-card',
            date: [],
            visible: false,
            tip: false,
            checkAll: false,
            checkAllStore: false,
            isIndeterminate: false,
            isSupportIndeterminate: false,
            form: {
                sellStoreIds: [],
                consumeWays: [],
                supportStoreIds: [],
                imageId: 1,
                saleBegin: null,
                saleEnd: null,
            },
            rules: {
                name: { type: 'string', required: true, message: this.$t('Fill.card_name') },
                basePrice: { type: 'number', required: true, message: this.$t('Fill.sell_base_amt') },
                actualValue: { type: 'number', required: true, message: this.$t('Fill.actual_value') },
                transferType: { required: true, message: this.$t('Choose.transfer_type') },
                supportStoreType: { required: true, message: this.$t('Choose.support_store_type') },
                sellStoreIds: { required: true, message: this.$t('Choose.sell_store2')},
                formalMemberOnly: { required: true, message: this.$t('Member.if') },
                consumeWays: { required: true, message: this.$t('Choose.pay_methods') },
                saleBegin: { type: 'string', required: true, message: this.$t('Fill.sell_start_time') },
                saleEnd: { type: 'string', required: true, message: this.$t('Fill.sell_end_time') },
                experienceCard: { required: true, message: this.$t('Choose.if_experience') },
                cardType: { required: true },
                validPeriod: { required: true, message: this.$t('Fill.validity_period') },
            },
            radio: false,
            options: [
                {
                    code: 2,
                    name: this.$t('Course.pay_group_course'),
                }, {
                    code: 3,
                    name: this.$t('Course.single_pay_personal'),
                },
            ],
            stores: [],
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        addImg(args) {
            this.form.image = args[0];
        },
        handleCheckAllChange(val) {
            this.form.supportStoreIds = val ? this.stores.map(el => el.id) : [];
            this.isSupportIndeterminate = false;
        },
        handleCheckedSupportStoresChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.stores.length;
            this.isSupportIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
        handleCheckAllStoreChange(val) {
            this.form.sellStoreIds = val ? this.stores.map(el => el.id) : [];
            this.isIndeterminate = false;
        },
        handleCheckedStoresChange(value) {
            const checkedCount = value.length;
            this.checkAllStore = checkedCount === this.stores.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.form = {
                sellStoreIds: [],
                consumeWays: [],
                supportStoreIds: [],
                imageId: 1,
                image: null,
                saleBegin: null,
                saleEnd: null,
            };
        },
        open(data) {
            if (this.activeName === 'memberCard') {
                this.title = this.$t('Card.card2');
                this.url = 'member-card';
            }
            if (data) {
                this.form.id = data;
                this.fetchData();
            }
            this.visible = true;
            this.fetchStore()
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        postData() {
            if (this.form.supportStoreType === 2 && this.form.supportStoreLimit > this.stores.length)
                return $ele.$message(this.$t('Message.tong_count'));
            const form = Object.assign({}, this.form);
            API.post(`${this.url}`, form).then(res => {
                if (res) {
                    $ele.$message.success(this.$t('Message.add_success'));
                    this.$emit('fetchData');
                    this.resetForm();
                }
                this.visible = false;
                this.$emit('input', 'update');
            });
        },
        putData() {
            if (this.form.supportStoreType === 2 && this.form.supportStoreLimit > this.stores.length)
                return $ele.$message(this.$t('Message.tong_count'));
            const form = Object.assign({}, this.form);
            API.put(`${this.url}/${this.form.id}`, form).then(res => {
                if (res) {
                    $ele.$message.success(this.$t('Message.edit_success'));
                    this.$emit('fetchData');
                    this.resetForm();
                }
                this.visible = false;
            });
        },
        confirm() {
            const transferFee = {
                transferFee: {
                    type: 'number',
                    required: true,
                    message: this.$t('Fill.transfer_fee'),
                },
            };
            this.rules = Object.assign({}, this.rules, transferFee);
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                // else if (!this.form.transferFee);
                else if (this.form.id) this.putData();
                else this.postData();
            });
        },
        fetchData() {
            if (!this.form.id) return;
            this.loading = true;
            API.get(`${this.url}/${this.form.id}`).then(res => {
                res.actualValue = Number(res.actualValue);
                res.basePrice = Number(res.basePrice);
                if (this.activeName === 'storedValueCard') {
                    res.consumeWays = res.consumeWays
                        ? res.consumeWays.map(el => el.consumeWayType)
                        : [];
                }
                res.transferFee = parseInt(res.transferFee, 10);
                res.supportStoreIds = res.supportStoreIds || [];
                this.form = res;
            });
        },
    },
    created() {
        this.fetchData();
    },
};
</script>

<style lang="scss">
.save-card-dialog {
    .el-dialog {
        width: 710px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 88vh;
        overflow-y: auto;
    }
    .image-item {
        margin-right: 10px;
        width: 94px;
        height: 54px;
        padding: 1px 2px;
        border: 1px solid rgb(59, 171, 239);
        background-size: cover;
        background-position: center;
    }
    .balance-pic {
        margin-right: 10px;
        width: 94px;
        height: 54px;
        padding: 1px 2px;
        border: 1px solid rgb(220, 223, 230);
        text-align: center;
    }
    .el-icon-plus {
        font-size: 20px;
        font-weight: bolder;
        color: rgb(220, 223, 230);
    }
    .box-1e {
        position: relative;
        left: 120px;
        margin-bottom: 15px!important;
        padding: 15px 15px 0 15px;
        background: #eee;
        width: 75%;
        min-height: 200px;
    }
    .label-name {
        display: inline-block;
        color: #4c4c4c;
        margin-bottom: 15px;
        text-align: right;
        line-height: 32px;
        white-space: nowrap;
    }
    .box-a {
        padding: 10px 15px;
        background: #fff !important;
        max-height: 140px !important;
        overflow: scroll;
    }
    .card-check-store {
        margin-top: 15px;
        border: 1px solid #e6e6e6;
        padding: 10px;
        max-height: 90px;
        overflow-y: auto;
    }
    .el-input {
        width: 180px;
        margin-right: 10px;
    }
    .el-select {
        width: 180px;
    }
}
.store-sell-end {
    .el-form-item__content {
        margin-left: 10px !important;
    }
}
.store-value-date {
    .el-form-item {
        padding: 0;
    }
}
</style>
